import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api';
import { timeEntryEndpoints } from '@/lib/api/endpoints';
import { timeEntryKeys } from '@/lib/queryKeys';

export function useDeleteTimeEntry(appointmentId: string, jobId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, string>({
    mutationFn: (entryId) => apiDelete(operationsClient, timeEntryEndpoints.delete(entryId)),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: timeEntryKeys.appointment(appointmentId),
      });
      if (jobId) {
        void queryClient.invalidateQueries({ queryKey: timeEntryKeys.jobRollup(jobId) });
      }
      toast.success('Time entry deleted');
    },
  });
}
